// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_X2w","cls2":"ClaimEvaluationRow-cls2_uxu ClaimEvaluationRow-cls1_X2w"};